/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewallevents2Inputs */

const en_overviewallevents2 = /** @type {(inputs: Overviewallevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All events`)
};

const de_overviewallevents2 = /** @type {(inputs: Overviewallevents2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Events`)
};

/**
* | output |
* | --- |
* | "All events" |
*
* @param {Overviewallevents2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewallevents2 = /** @type {((inputs?: Overviewallevents2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewallevents2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewallevents2(inputs)
	return de_overviewallevents2(inputs)
});
export { overviewallevents2 as "overviewAllEvents" }